import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { BackendService } from './backend.service';
import { PermissionsService } from './permissions.service';
import { StatusHelperService } from './status-helper.service';
import { WellRequestStatus_Options } from '../model/status-enum.model';
import { IUser } from '../model/user.model';


@Injectable({
  providedIn: 'root'
})
export class RoutingService {
  private routeMapBackUser: [RegExp, Function][] = [
    [/^\/well-request\/new(?:\?.*)?$/,() => { this.router.navigate(['/well-request/my']) }],
    [/^\/well-request\/edit(?:\/\d+)?$/, () => { this.router.navigate(['/well-request/my']) }],
    [/^\/well-request\/view\/\d+$/, () => { this.router.navigate(['/well-request/my']) }],
    [/^\/well-request\/log(?:\/\d+)?$/, () => { this.navigateHistoryBack() }],
    [/^\/well-request\/approve\/\d+$/, () => { this.router.navigate(['/well-request/my']) }],
    [/^\/well-request\/review\/\d+$/, () => { this.router.navigate(['/well-request/my']) }],
  ];

  private routeMapBackAdmin: [RegExp, Function][] = [
    [/^\/well-request\/new(?:\?.*)?$/, () => { this.router.navigate(['/well-request/my']) }],
    [/^\/well-request\/edit(?:\/\d+)?$/, () => { this.router.navigate(['/well-request/my']) }],
    [/^\/well-request\/approve\/\d+$/, () => { this.router.navigate(['/well-request/pending'])}],
    [/^\/well-request\/review\/\d+$/, () => { this.router.navigate(['/well-request/all']) }],
    [/^\/well-request\/view\/\d+$/, () => { this.router.navigate(['/well-request/my']) }],
    [/^\/well-request\/log(?:\/\d+)?$/, () => { this.navigateHistoryBack() }]
  ];


  private static _tabToBack: ReplaySubject<string>;
  private static _path: string | undefined;
  constructor(public router: Router,
    private _backendService: BackendService,
    public activatedRoute: ActivatedRoute,
    private _location: Location,
    private _permisstionService: PermissionsService) {
    if (!RoutingService._tabToBack) {
      RoutingService._tabToBack = new ReplaySubject<string>();
      this.getRouteValue();
    }
  }

  static get tabToBack$(): Observable<string> {
    if (!RoutingService._tabToBack) {
      RoutingService._tabToBack = new ReplaySubject<string>();
    }
    return RoutingService._tabToBack.asObservable();
  }

  back() {
    if (!RoutingService._path){
      console.log('back', this.router.url, this.getWellRequestId().toString());
      this.routeMapper(this.router.url, this.getWellRequestId().toString());
    }
    else
      this._location.back();
  }

  adminRedirect() {
    this.redirect('/well-request/pending');    
  }

  cancelRedirect() {
    this.redirect('/well-request/my');    
  }

  tabRedirect(route: ActivatedRouteSnapshot) {
    if (RoutingService._path) {
      console.log('tabRedirect', RoutingService._path);
      this.router.navigate([RoutingService._path]);
    }
    else {
      const id = parseInt(route.paramMap.get('id') || "-1");
      const fullUrl: string = '/' + route.url.map(segment => segment.path).join('/');
      console.log('tabRedirect', fullUrl, id.toString());
      this.routeMapper(fullUrl, id.toString())
    }
  }

  redirectToDefault() {
    this.router.navigate(['/well-request/my']);
  }

  async forwardRedirect(wellRequestId: string, status: WellRequestStatus_Options | undefined) {
    console.log('forwardRedirect', wellRequestId, status);
    const isAdmin = await this._backendService.getCheckIsAdminsForAnyGroup().toPromise();
    console.log('forwardRedirectisAdmin', isAdmin);
    const isAdminUser = isAdmin === true || !!(isAdmin && (isAdmin as IUser[])?.length > 0);
    console.log('forwardRedirect isAdminUser', isAdminUser);
    const route = StatusHelperService.GetHrefByStatus(status, isAdminUser);
    console.log('forwardRedirect route', route);
    if (route) {
      console.log('forwardRedirect navigating');
      this.router.navigate([route, wellRequestId]);
    } else {
      console.log('forwardRedirect no route found');
    }
  }

  async redirectToApproval(wellRequestId: string) {
    console.log('redirectToApproval', wellRequestId);
    this.router.navigate(['/well-request/approve', wellRequestId]);
  }

  setRoute(status: string) {
    console.log('setRoute', status);
    RoutingService._tabToBack.next(status);
  }

  getWellRequestId(): number {
    return parseInt(this.activatedRoute.snapshot.paramMap.get('id') ?? "-1");
  }

  private navigateHistoryBack(): void {
    const id = this.getWellRequestId();
    this._backendService.getWellRequest(id.toString()).subscribe((wellRequest) => {
      this.forwardRedirect(id.toString(), wellRequest.currentStatusId);
    });
  }

  private redirect(tabPath: string) {
    if (!RoutingService._path) {
      console.log('redirect', tabPath);
      this.router.navigate([tabPath]);
    }
    else {
      console.log('redirect', RoutingService._path);
      this.router.navigate([RoutingService._path]);
    }
  }

  private getRouteValue() {
    RoutingService.tabToBack$.subscribe((data) => {
      RoutingService._path = data;
    });
  }

  private routeMapper(route: string, wellRequestId: string) {
    if (wellRequestId == '-1') {
      this.setTab(this.routeMapBackUser, route);
      return;
    }

    this._backendService.getCheckIsAdmins(wellRequestId).subscribe((isAdmin) => {
      if (isAdmin)
        this.setTab(this.routeMapBackAdmin, route)
      else
        this.setTab(this.routeMapBackUser, route)
    })
     
    this.routeMapBackUser
  }

  private setTab(routeMap: [RegExp, Function][], route: string) {
    routeMap.forEach(([pattern, func]) => {
      if (pattern.test(route)) {
        func();
      }
    });
  }
}
